'use client';
import React, { useEffect, useMemo, useState } from 'react';
import styles from '@/assets/styles/pages/home/Faqs.module.scss';
import { SupportController } from '@/controllers';
import { supportStore } from '@/stores';
import { MimaText, PageLoader, PageLayout2 } from '@/components';
import { GrFormAdd, GrFormSubtract } from 'react-icons/gr';
import { IFaqDTO } from '@/interfaces';

const Faqs = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getFaqsList = async () => {
      setLoading(true);
      await SupportController.faqCategories();
      setLoading(false);
    };
    getFaqsList();
  }, []);

  const { faqs } = supportStore;

  const faqItems: IFaqDTO[] = useMemo(() => {
    return faqs.filter((x: IFaqDTO) => {
      return x.faqs.length > 0;
    });
  }, [faqs]);

  const [answer, setAnswer] = useState(-1);
  const [data, setData] = useState(faqItems[0]);
  const [selected, setSelected] = useState(0);

  const showAnswer = (i: number) => {
    if (answer === i) {
      return setAnswer(-1);
    } else {
      setAnswer(i);
    }
  };
  return (
    <PageLayout2>
      <div className={styles.container}>
        <MimaText variant="h3" align="center" color="var(--color-dark)">
          FAQs
        </MimaText>
        <MimaText variant="bodyBold" align="center" mt={2} mb={4}>
          See answers to previously asked questions
        </MimaText>
        {loading ? (
          <PageLoader loading={loading} />
        ) : (
          <div className={styles.container_faqs}>
            <div>
              <MimaText variant="bodyBold" mb={1}>
                Content
              </MimaText>
              <div className={styles.nav}>
                {faqItems?.map((item: IFaqDTO, index: number) => {
                  return (
                    <div
                      className={selected === index ? styles.nav_item_active : styles.nav_item}
                      onClick={() => {
                        setData(item);
                        setSelected(index);
                      }}
                      key={index}
                    >
                      {item.name}
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              {data
                ? data?.faqs?.map((x: any, i: number) => {
                  return (
                    <div key={i} className={styles.aside__ans}>
                      <div
                        className={answer === i ? styles.signs__active : styles.signs}
                        onClick={() => {
                          showAnswer(i);
                        }}
                      >
                        <div className={styles.icon}>{answer === i ? <GrFormSubtract /> : <GrFormAdd />}</div>
                        <div>{x?.question}</div>
                      </div>
                      {answer === i && <MimaText ml={3}>{x?.answer}</MimaText>}
                    </div>
                  );
                })
                : null}
            </div>
          </div>
        )}
      </div>
    </PageLayout2>
  );
};

export default Faqs;
